<script>
export default {
  props: {
    value: {
      type: [File, String],
      required: false,
      default: ""
    }
  },

  data() {
    return {
      picture: "/static/user-default.svg"
    };
  },

  computed: {
    previewPicture() {
      return this.picture != "/static/user-default.svg"
        ? URL.createObjectURL(this.picture)
        : "/static/user-default.svg";
    }
  },

  methods: {
    getPicture(e) {
      const picture = e.target.files[0];

      if (!this.checkPictureType(picture.type))
        this.$toasted.error("A imagem deve ter a extensão JPG ou PNG!");

      this.$emit("input", picture);
    },
    checkPictureType(pictureType) {
      const acceptableTypes = ["image/png", "image/jpeg"];
      return acceptableTypes.includes(pictureType);
    }
  },

  watch: {
    value(val) {
      if (val) this.picture = val;
    }
  }
};
</script>

<template>
  <div>
    <input id="picture" type="file" accept="image/*" @change="getPicture" />
    <label for="picture">
      <img :src="previewPicture" width="100%" />
      <div>
        <img src="/static/menu-user.svg" height="40px" /> adicione uma foto
      </div>
    </label>
  </div>
</template>

<style lang="scss" scoped>
input {
  display: none;
}

label {
  width: 130px;
  height: 130px;
  border-radius: 100%;
  text-align: center;
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  > img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    object-fit: cover;
    object-position: center;
    transition: all 0.25s ease;
  }

  &[src="#"] {
    opacity: 0;
  }

  div {
    @extend %flex-column-center;
    font-size: 12px;
    color: white;
    background: linear-gradient(
      45deg,
      rgba($purple, 0.5) 0%,
      rgba($pink, 0.5) 100%
    );
    border-radius: 100%;
    width: 100%;
    height: 100%;
    margin-top: -100%;
    opacity: 0;
    cursor: pointer;
    transition: all 0.25s ease;
    z-index: 1;

    img {
      margin-bottom: 10px;
    }
  }

  &:hover {
    > img {
      filter: blur(4px);
      transform: scale(1.1);
    }

    div {
      opacity: 1;
    }
  }

  @media (min-width: 768px) {
    width: 150px;
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Profile/Picture.vue